import React from 'react';
import './services.css';

const Services = () => {
  const services = [
    {
      title: "Bespoke Tailoring",
      description: "Complete custom garments crafted from scratch with personal pattern drafting and premium fabric selection.",
      icon: "fa-scissors",
      features: ["Personal Pattern Drafting", "Premium Fabric Selection", "Multiple Fittings", "Hand-Finished Details"]
    },
    {
      title: "Custom Design",
      description: "Transform your vision into wearable art through creative collaboration and technical design expertise.",
      icon: "fa-palette",
      features: ["Creative Collaboration", "Technical Design Sketches", "Material Sourcing", "Prototype Development"]
    },
    {
      title: "Personal Styling",
      description: "Cohesive wardrobe solutions tailored to your lifestyle with color analysis and seasonal planning.",
      icon: "fa-vest",
      features: ["Wardrobe Assessment", "Color Analysis", "Body Type Consulting", "Seasonal Planning"]
    },
    {
      title: "VIP Consultations",
      description: "Exclusive private appointments with priority scheduling and personalized attention for your convenience.",
      icon: "fa-crown",
      features: ["Priority Scheduling", "Private Appointments", "Location Flexibility", "Extended Consultations"]
    },
    {
      title: "Alterations & Repairs",
      description: "Precision alterations and expert repairs to restore and perfect your existing garments.",
      icon: "fa-tools",
      features: ["Precision Alterations", "Expert Repairs", "Vintage Restoration", "Size Adjustments"]
    },
    {
      title: "Wedding & Special Events",
      description: "Bridal and special occasion wear crafted with exceptional attention to detail and elegance.",
      icon: "fa-ring",
      features: ["Bridal Wear", "Formal Attire", "Event Coordination", "Custom Accessories"]
    }
  ];

  return (
    <div className="services">
      <div className="bg__grid"></div>
      <div className="bg__orb orb-1"></div>
      <div className="bg__orb orb-2"></div>
      
      <div className="services__container">
        <nav className="holographic__nav">
          <a href='/tailor' className="nav__item">About</a>
          <a href='/tailorprofiles' className="nav__item">Tailors</a>
          <a href='/tailorservices' className="nav__item nav__item--active">Services</a>
        </nav>

        <main className="content__main">
          <div className="content__wrapper">
            <section className="title__section">
              <div className="title__glow"></div>
              <h2 className="content__title">
                <span className="title__text">OUR SERVICES</span>
                <div className="title__line"></div>
              </h2>
              <p className="content__subtitle">ADVANCED CRAFTSMANSHIP FOR THE MODERN ERA</p>
            </section>

            <div className="services__grid">
              {services.map((service, index) => (
                <div key={index} className="service__card">
                  <div className="card__glow"></div>
                  <div className="service__header">
                    <div className="service__icon">
                      <i className={`fas ${service.icon}`}></i>
                    </div>
                    <h3>{service.title}</h3>
                  </div>
                  <p className="service__description">{service.description}</p>
                  <div className="features__list">
                    {service.features.map((feature, featureIndex) => (
                      <div key={featureIndex} className="feature__item">
                        <i className="fas fa-check"></i>
                        <span>{feature}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="process__section">
              <div className="content__panel">
                <div className="panel__glow"></div>
                <h3 className="process__title">THE ENERSTIC PROCESS</h3>
                <div className="process__steps">
                  <div className="process__step">
                    <div className="step__number">01</div>
                    <h4>CONSULTATION</h4>
                    <p>Deep dive into your vision and requirements</p>
                  </div>
                  <div className="process__step">
                    <div className="step__number">02</div>
                    <h4>DESIGN</h4>
                    <p>Create technical sketches and material selection</p>
                  </div>
                  <div className="process__step">
                    <div className="step__number">03</div>
                    <h4>CRAFTING</h4>
                    <p>Precision execution with advanced techniques</p>
                  </div>
                  <div className="process__step">
                    <div className="step__number">04</div>
                    <h4>DELIVERY</h4>
                    <p>Final fitting and quality assurance</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Services;